import { useState, useEffect } from 'react';
import { Carousel, CarouselItem, CarouselControl } from 'reactstrap';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const ImageCarousel = ({ images, defaultImage, corFundo }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [forceRender, setForceRender] = useState(0);
  
  // Normaliza as imagens (garante que sempre tenha pelo menos uma)
  const normalizedImages = images?.length > 0 ? images : [{ url: defaultImage, id: 0 }];
  
  // Função para forçar redesenho quando as imagens mudarem
  useEffect(() => {
    setForceRender(prev => prev + 1);
    setActiveIndex(0);
  }, [images]);

  // Navegação do carrossel
  const next = () => {
    const nextIndex = activeIndex === normalizedImages.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    const nextIndex = activeIndex === 0 ? normalizedImages.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  // Controles do modal
  const openModal = (index) => {
    setActiveIndex(index);
    setModalIsOpen(true);
  };

  const closeModal = () => setModalIsOpen(false);

  // Componente de imagem reutilizável
  const ImageComponent = ({ img, index, onClick }) => (
    <div 
      style={{
        position: 'relative',
        height: '150px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#CECECE',
        cursor: 'pointer'
      }}
      onClick={onClick}
    >
      <img
        src={img.url || defaultImage}
        alt={`Imagem ${index + 1}`}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
       //   position: 'absolute'
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = defaultImage;
        }}
      />
      <div style={{
        position: 'absolute',
        bottom: '10px',
        right: '10px',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
        padding: '2px 8px',
        borderRadius: '10px',
        fontSize: '0.8rem'
      }}>
        {index + 1}/{normalizedImages.length}
      </div>
    </div>
  );

  return (
    <div key={`gallery-${forceRender}`} style={{ position: 'relative' }}>
      {/* Carrossel para múltiplas imagens */}
      {normalizedImages.length > 1 ? (
        <Carousel
          activeIndex={activeIndex}
          next={next}
          previous={previous}
          interval={false}
        >
          {normalizedImages.map((img, index) => (
            <CarouselItem key={`${img.id}-${index}`}>
              <ImageComponent 
                img={img} 
                index={index} 
                onClick={() => openModal(index)} 
              />
            </CarouselItem>
          ))}
          <CarouselControl 
            direction="prev" 
            directionText="Anterior" 
            onClickHandler={previous} 
          />
          <CarouselControl 
            direction="next" 
            directionText="Próximo" 
            onClickHandler={next} 
          />
        </Carousel>
      ) : (
        /* Exibição direta para única imagem */
        <ImageComponent 
          img={normalizedImages[0]} 
          index={0} 
          onClick={() => openModal(0)} 
        />
      )}

      {/* Modal/Lightbox */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: 0,
            border: 'none',
            background: 'none',
            maxWidth: '90vw',
            maxHeight: '90vh'
          },
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.9)',
            zIndex: 9999
          }
        }}
      >
        <div style={{ position: 'relative' }}>
          <img
            src={normalizedImages[activeIndex]?.url || defaultImage}
            alt="Imagem ampliada"
            style={{ 
              maxHeight: '80vh',
              maxWidth: '80vw',
              display: 'block'
            }}
          />
          
          {normalizedImages.length > 1 && (
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '0',
              right: '0',
              display: 'flex',
              justifyContent: 'space-between',
              transform: 'translateY(-50%)',
              padding: '0 20px'
            }}>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  previous();
                }}
                style={{
                  background: 'rgba(0,0,0,0.7)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  fontSize: '20px',
                  cursor: 'pointer'
                }}
              >
                ‹
              </button>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  next();
                }}
                style={{
                  background: 'rgba(0,0,0,0.7)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  fontSize: '20px',
                  cursor: 'pointer'
                }}
              >
                ›
              </button>
            </div>
          )}
          
          <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'rgba(0,0,0,0.7)',
            color: 'white',
            padding: '5px 15px',
            borderRadius: '20px'
          }}>
            {activeIndex + 1}/{normalizedImages.length}
          </div>
          
          <button 
            onClick={closeModal}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'rgba(0,0,0,0.7)',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              fontSize: '20px',
              cursor: 'pointer'
            }}
          >
            ×
          </button>
        </div>
      </Modal>
    </div>
  );
};

  export default ImageCarousel;
